export default {"src":"/_next/static/media/customers_heart_01.6172e38f.svg","height":80,"width":93,"blurWidth":0,"blurHeight":0};